import type { DataTableColumn } from "@octopusdeploy/design-system-components";
import { SimpleDataTable } from "@octopusdeploy/design-system-components";
import { sortBy } from "lodash";
import React from "react";
import { allPagesFlattened } from "~/routing/pageRegistrations/allPageRegistrations";
import type { PageOwner } from "~/routing/pageRegistrations/pageOwner";
export function SiteMapTab() {
    const pages = allPagesFlattened.map((p) => createSiteMapRow(p.route.getDebugString(), p.pageId, p.pageName, p.pageArea, p.owner));
    const orderedPages = sortBy(pages, [(r) => r.pageArea, (r) => r.pageName]);
    const columns: DataTableColumn<SiteMapRow>[] = [
        { title: "Area", render: (p) => p.pageArea, columnSize: "small" },
        { title: "Page Name", render: (p) => p.pageName, columnSize: "small" },
        { title: "Page Id", render: (p) => p.pageId, columnSize: "small" },
        { title: "Owner", render: (p) => p.owner, columnSize: "small" },
        { title: "Route", render: (p) => p.templatedRoute },
    ];
    return <SimpleDataTable columns={columns} data={orderedPages} getRowKey={(r) => r.templatedRoute}/>;
}
function createSiteMapRow(routeDebugString: string, pageId: string, pageName: string, pageArea: string, owner: PageOwner): SiteMapRow {
    return {
        pageArea,
        pageId,
        pageName,
        owner,
        templatedRoute: routeDebugString,
    };
}
interface SiteMapRow {
    pageArea: string;
    pageName: string;
    pageId: string;
    owner: PageOwner;
    templatedRoute: string;
}
